import React from 'react'

 const Carottes = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="62.964" height="62.963" viewBox="0 0 62.964 62.963">
    <g id="Group_18135" data-name="Group 18135" transform="translate(-309.636 -265.405)">
      <g id="Group_18083" data-name="Group 18083">
        <path id="Path_19126" data-name="Path 19126" d="M359.6,278.367l3.118-1.134,6.564-6.767-.935-.914-8.729,8.762Z" fill="#94af20"/>
      </g>
      <g id="Group_18084" data-name="Group 18084">
        <path id="Path_19127" data-name="Path 19127" d="M368.35,269.553l-1.115-1.09-6.606,6.811-1.008,3.041Z" fill="#abc820"/>
      </g>
      <g id="Group_18085" data-name="Group 18085">
        <path id="Path_19128" data-name="Path 19128" d="M360.882,265.4l-3.928,11.86q.5.367.979.787c.242.211.479.434.714.663.045.045.1.085.14.131l.153.153.61-.612.072-.072,1.007-3.041,2.968-8.963Z" fill="#def05e"/>
      </g>
      <g id="Group_18086" data-name="Group 18086">
        <path id="Path_19129" data-name="Path 19129" d="M371.626,274l-8.9,3.237-3.118,1.134.018-.052-.072.072-.61.612.035.036c.106.106.2.217.3.325.23.243.455.488.665.739.257.307.5.619.728.936L372.6,276.7Z" fill="#accf1b"/>
      </g>
      <path id="Path_19130" data-name="Path 19130" d="M360.669,281.035c-.227-.317-.471-.629-.728-.936-.21-.251-.435-.5-.665-.739-.1-.108-.2-.219-.3-.325L358.94,279l-.153-.153c-.045-.047-.1-.086-.14-.131-.235-.23-.472-.452-.714-.663q-.48-.418-.979-.787c-4.7-3.472-10.456-3.514-14.22,1.377l-2.621,3.406c-1.973,2.565-4.882,6.344-8.107,10.535-3.322,4.318-6.972,9.06-10.271,13.347-3.251,4.223-6.16,8-8.065,10.48a17.115,17.115,0,0,0-1.011,1.514c-1.808,2.986-4.1,8.16-2.458,9.811l.07.07c.008.008.02.012.028.02,2.014,1.935,9.045-1.789,11.255-3.5,9.405-7.294,37.624-29.175,37.624-29.175C363.995,291.413,364.011,285.719,360.669,281.035Z" fill="#f93"/>
      <g id="Group_18090" data-name="Group 18090">
        <g id="Group_18087" data-name="Group 18087">
          <path id="Path_19131" data-name="Path 19131" d="M350.6,283.51l-2.913-2.925c-.085-.085-.3-.007-.482.175l3.221,3.233C350.608,283.811,350.687,283.6,350.6,283.51Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18089" data-name="Group 18089">
          <g id="Group_18088" data-name="Group 18088">
            <path id="Path_19132" data-name="Path 19132" d="M350.427,283.993l-3.221-3.233c-.181.182-.26.4-.174.484l2.913,2.925C350.03,284.254,350.246,284.175,350.427,283.993Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18094" data-name="Group 18094">
        <g id="Group_18091" data-name="Group 18091">
          <path id="Path_19133" data-name="Path 19133" d="M344.215,286.271l-2.468-2.477c-.072-.072-.277.017-.458.2l2.727,2.738C344.2,286.549,344.287,286.343,344.215,286.271Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18093" data-name="Group 18093">
          <g id="Group_18092" data-name="Group 18092">
            <path id="Path_19134" data-name="Path 19134" d="M344.016,286.731l-2.727-2.738c-.181.182-.27.388-.2.46l2.468,2.477C343.63,287,343.835,286.913,344.016,286.731Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18098" data-name="Group 18098">
        <g id="Group_18095" data-name="Group 18095">
          <path id="Path_19135" data-name="Path 19135" d="M336.406,297.161l-2.325-2.333c-.067-.067-.268.025-.45.207l2.568,2.578C336.381,297.431,336.473,297.229,336.406,297.161Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18097" data-name="Group 18097">
          <g id="Group_18096" data-name="Group 18096">
            <path id="Path_19136" data-name="Path 19136" d="M336.2,297.613l-2.568-2.578c-.181.182-.273.384-.206.452l2.324,2.333C335.816,297.888,336.018,297.8,336.2,297.613Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18102" data-name="Group 18102">
        <g id="Group_18099" data-name="Group 18099">
          <path id="Path_19137" data-name="Path 19137" d="M346.979,299.146l-3.216-3.227c-.093-.094-.315-.023-.5.159l3.554,3.568C347,299.464,347.073,299.24,346.979,299.146Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18101" data-name="Group 18101">
          <g id="Group_18100" data-name="Group 18100">
            <path id="Path_19138" data-name="Path 19138" d="M346.82,299.646l-3.554-3.568c-.181.182-.252.406-.159.5l3.216,3.227C346.416,299.9,346.639,299.828,346.82,299.646Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18106" data-name="Group 18106">
        <g id="Group_18103" data-name="Group 18103">
          <path id="Path_19139" data-name="Path 19139" d="M354.909,293.521l-2.156-2.164c-.063-.063-.26.034-.441.216l2.382,2.391C354.876,293.782,354.971,293.584,354.909,293.521Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18105" data-name="Group 18105">
          <g id="Group_18104" data-name="Group 18104">
            <path id="Path_19140" data-name="Path 19140" d="M354.694,293.964l-2.382-2.391c-.182.182-.278.38-.216.443l2.156,2.164C354.315,294.243,354.513,294.147,354.694,293.964Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18110" data-name="Group 18110">
        <g id="Group_18107" data-name="Group 18107">
          <path id="Path_19141" data-name="Path 19141" d="M357.908,287.929l-2.741-2.751c-.08-.081-.291,0-.473.184l3.029,3.042C357.9,288.221,357.988,288.009,357.908,287.929Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18109" data-name="Group 18109">
          <g id="Group_18108" data-name="Group 18108">
            <path id="Path_19142" data-name="Path 19142" d="M357.723,288.4l-3.029-3.042c-.181.182-.264.394-.184.474l2.741,2.752C357.331,288.668,357.543,288.585,357.723,288.4Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18114" data-name="Group 18114">
        <g id="Group_18111" data-name="Group 18111">
          <path id="Path_19143" data-name="Path 19143" d="M328.6,307.428l-2.808-2.819c-.082-.082-.286-.01-.457.162l3.1,3.116C328.612,307.715,328.684,307.51,328.6,307.428Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18113" data-name="Group 18113">
          <g id="Group_18112" data-name="Group 18112">
            <path id="Path_19144" data-name="Path 19144" d="M328.442,307.887l-3.1-3.116c-.171.172-.244.377-.162.459l2.809,2.819C328.067,308.131,328.271,308.058,328.442,307.887Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18118" data-name="Group 18118">
        <g id="Group_18115" data-name="Group 18115">
          <path id="Path_19145" data-name="Path 19145" d="M338.924,307.988l-2.808-2.82c-.082-.081-.287-.009-.457.162l3.1,3.116C338.934,308.275,339.006,308.07,338.924,307.988Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18117" data-name="Group 18117">
          <g id="Group_18116" data-name="Group 18116">
            <path id="Path_19146" data-name="Path 19146" d="M338.762,308.446l-3.1-3.116c-.171.172-.243.377-.162.459l2.809,2.819C338.387,308.69,338.592,308.618,338.762,308.446Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18122" data-name="Group 18122">
        <g id="Group_18119" data-name="Group 18119">
          <path id="Path_19147" data-name="Path 19147" d="M328.734,316l-1.843-1.851c-.054-.054-.221.026-.373.179l2.039,2.046C328.709,316.222,328.788,316.055,328.734,316Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18121" data-name="Group 18121">
          <g id="Group_18120" data-name="Group 18120">
            <path id="Path_19148" data-name="Path 19148" d="M328.557,316.375l-2.039-2.046c-.151.152-.231.319-.177.373l1.844,1.851C328.238,316.607,328.4,316.527,328.557,316.375Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18126" data-name="Group 18126">
        <g id="Group_18123" data-name="Group 18123">
          <path id="Path_19149" data-name="Path 19149" d="M318.813,316.54l-1.281-1.285c-.037-.038-.168.034-.294.16l1.415,1.421C318.779,316.71,318.851,316.577,318.813,316.54Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18125" data-name="Group 18125">
          <g id="Group_18124" data-name="Group 18124">
            <path id="Path_19150" data-name="Path 19150" d="M318.653,316.836l-1.415-1.421c-.126.126-.2.258-.16.295L318.359,317C318.4,317.034,318.528,316.962,318.653,316.836Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18130" data-name="Group 18130">
        <g id="Group_18127" data-name="Group 18127">
          <path id="Path_19151" data-name="Path 19151" d="M319.543,323.017l-1.165-1.169c-.033-.034-.153.031-.266.145l1.287,1.291C319.512,323.171,319.576,323.051,319.543,323.017Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18129" data-name="Group 18129">
          <g id="Group_18128" data-name="Group 18128">
            <path id="Path_19152" data-name="Path 19152" d="M319.4,323.284l-1.287-1.291c-.113.113-.177.233-.144.267l1.165,1.169C319.166,323.462,319.286,323.4,319.4,323.284Z" fill="#f78721"/>
          </g>
        </g>
      </g>
      <g id="Group_18134" data-name="Group 18134">
        <g id="Group_18131" data-name="Group 18131">
          <path id="Path_19153" data-name="Path 19153" d="M312.936,322.638l-.826-.829c-.025-.024-.166.079-.317.231l.912.916C312.857,322.8,312.959,322.662,312.936,322.638Z" fill="#ffd7b3"/>
        </g>
        <g id="Group_18133" data-name="Group 18133">
          <g id="Group_18132" data-name="Group 18132">
            <path id="Path_19154" data-name="Path 19154" d="M312.7,322.956l-.912-.916c-.151.151-.254.294-.23.318l.825.829C312.413,323.211,312.554,323.108,312.7,322.956Z" fill="#f78721"/>
          </g>
        </g>
      </g>
    </g>
  </svg>

  );
};
export default Carottes
